<template>
  <v-main>
    <v-card class="idcs-dialog-back fill-height">
      <v-card-actions>
        <v-subheader>{{$store.getters['admin/msgById']({name_id:item.nameId}, $i18n.locale)}}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
          <v-form ref="form" :lazy-validation="true">
            <v-row>
              <v-col cols="2">
                <v-text-field
                  v-model="item.id"
                  :label="$t('field.repid')"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :disabled="!clone"
                  :rules="digitsRules"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="item.nameId"
                  :label="$t('field.nameId')"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :rules="digitsRules"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-text-field
                      v-model="item.sorted"
                      shaped
                      outlined
                      background-color="yellow lighten-5"
                      color="black"
                      :label="$t('field.sorted')"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>{{$t("report.tt.sorted")}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="item.inputPars"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="$t('field.inputPars')"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="item.filtrs"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="$t('field.filtrs')"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="item.fields"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="$t('field.fields')"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="item.totals"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="$t('field.totals')"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="item.additional"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="$t('field.additional')"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="item.sysdata"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="$t('field.sysdata')"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-alert
                  v-model="showAlert"
                  border="left"
                  colored-border
                  type="error"
                  elevation="2"
                  :dismissible="true"
                  transition="fade-transition"
                >{{alertMessage}}</v-alert>
              </v-col>
            </v-row>
          </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="!clone && $store.getters.test('ReportRecord.d')"
          color="blue darken-1"
          text
          @click="simpleDialog=true"
        >{{$t('button.delete')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!clone && $store.getters.test('ReportRecord.c')"
          color="blue darken-1"
          text
          @click="copy"
        >{{$t('button.clone')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('ReportRecord.w')"
          color="blue darken-1"
          text
          @click="save"
        >{{$t('button.save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="simpleDialog" persistent max-width="300">
      <v-card class="mx-auto">
        <v-card-title>
          <span>{{$t('button.ok')}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="simpleDialog=false" icon>
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>{{$t('dialog.delete')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="erase">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
//import axios from "axios";
import app from "@/app.js";
const rec_type = "ReportRecord";

export default {
  name: "UserEditor",
  props: {
    record: { type: Object, required: true },
    value: { type: Boolean },
    newrec: { type: Boolean, default: false }
  },
  data() {
    return {
      clone: this.newrec,
      simpleDialog: false,
      showAlert: false,
      alertMessage: "",
      digitsRules: [
        v => !!v || this.$t("error.required"),
        v => /\d{1,8}/.test(v) || this.$t("error.digits")
      ],

      item: { ...this.record }
    };
  },
  watch: {
    record: {
      handler(nw) {
        this.item = { ...nw };
        this.clone = !nw.id;
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    erase() {
      this.$store
        .dispatch("admin/DEL_REPORT", this.item.id)
        .then(() => {
          this.close();
        })
        .catch(error => {
          this.showAlertMessage(error);
        });
    },
    close() {
      this.$emit("input", false);
    },
    copy() {
      this.item.id = "";
      this.clone = true;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let params = {
        id: this.item.id,
        filtrs: this.item.filtrs,
        totals: this.item.totals,
        nameId: this.item.nameId,
        fields: this.item.fields,
        sorted: this.item.sorted,
        sysData: this.item.sysData,
        inputPars: this.item.inputPars
      };
      app
        .update(this.record.id, rec_type, params)
        .then(() => {
          this.item.rec_type = rec_type;
          if (this.clone && this.item.id != this.record.id) {
            this.item.name_id = this.item.nameId;
            this.$store.commit("admin/insert_report", this.item);
          }
          this.close();
        })
        .catch(error => {
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    }
  }
};
</script>

<style scoped>
</style>